import Collapse from 'bootstrap/js/dist/collapse';
// Keep layout/header Bootstrap data-api behavior alive without exposing a global bootstrap object.
void Collapse;
